<template>
  <div class="px-4">
    <div v-if="carrinho.length === 0">
      <v-card height="300px" v-if="user">
        <v-row style="height: 100%;" align="center" justify="center">
          <v-col cols="12" align="center" justify="center">
            <div class="title font-weight-black" v-if="!pedido">
              Carrinho vazio!
            </div>
            <div class="title font-weight-black" v-if="pedido">
              Pedido gerado com sucesso!
            </div>
            <div class="subtitle-1 font-weight-light pt-4" v-if="pedido">
              Número do pedido
              <div class="font-weight-black title">{{ pedido.bpdIntCod }}</div>
              <div class="pt-4">
                <v-btn
                  v-if="pedido.bpdStrBoletoUrl"
                  :href="pedido.bpdStrBoletoUrl"
                  color="var(--vs-azul-primaria)"
                  outlined
                  target="_blank"
                  class="font-weight-black"
                >
                  <v-icon class="pr-2">la-file-invoice-dollar</v-icon>GERAR
                  BOLETO
                </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </div>
    <div v-if="carrinho.length > 0" class="hidden-sm-and-down">
      <v-card>
        <v-simple-table light class="carrinho-table">
          <thead>
            <tr>
              <th class="text-left font-weight-bold pl-8">Qtd.</th>
              <th class="text-left font-weight-bold">Item</th>
              <th class="text-right font-weight-bold pr-12" v-if="!orcamento">
                Total
              </th>
              <th class="text-left" width="10px"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(c, i) in carrinho" :key="i">
              <td class="text-center pr-0 pl-8" style="width: 110px">
                <v-text-field
                  min="1"
                  max="100"
                  v-model="c.carIntQtd"
                  @input="alterarQuantidade(c)"
                  type="number"
                  required
                  style="width:50px;"
                  id="numeroCentralizado"
                ></v-text-field>
              </td>
              <td class="text-left pr-0 pl-3">
                <div>
                  {{ c.anuncio.fitStrCoditefabricante }} -
                  {{ c.anuncio.fitStrNme }}
                </div>
              </td>
              <td class="text-right pr-12 pl-2" v-if="!orcamento">
                {{
                  parseFloat((c.anuncio.ancFltPrecoVendaDesconto * c.carIntQtd)).toFixed(2).replace('.', ',') | currency
                }}
              </td>
              <td class="pr-0 pl-2">
                <v-btn
                  text
                  @click="removerCompra(i)"
                  class="pa-0"
                  style="min-width: 0px;"
                >
                  <v-icon small dark color="var(--vs-vermelho)" class="pr-12"
                    >delete</v-icon
                  >
                </v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table>

        <v-row no-gutters>
          <v-col cols="6" class="pl-12">
            <OpcaoEntega class="mb-4" />

            <CalcFrete v-if="tipoEntrega === 'FRT'" class="mb-8" />
          </v-col>
          <v-col cols="6">
            <v-row no-gutters>
              <v-col cols="7">
                <span class="text-left pr-0 pl-3 py-0 text-right">Frete</span>
              </v-col>
              <v-col cols="4">
                <span
                  class="text-left pr-12 pl-2 py-0 float-right"
                  v-if="valorFrete === retornoValorFreteNull"
                  ></span
                >
                <span
                  class="text-left pr-12 pl-2 py-0 float-right"
                  v-else-if="valorFrete == retornoValorFreteZero"
                  >FRETE GRÁTIS</span
                >
                <span
                  class="text-left pr-12 pl-2 py-0 float-right"
                  v-else-if="valorFrete === true"
                ></span>
                <span class="text-left pr-12 pl-2 py-0 float-right" v-else>{{
                  parseFloat(valorFrete).toFixed(2).replace('.', ',') | currency
                }}</span>
              </v-col>
              <v-col cols="7">
                <span
                  class="text-left pr-0 pl-3 py-0 text-right"
                  v-if="carrinho.length > 1"
                  >{{ carrinho.length }} produtos</span
                >
                <span class="text-left pr-0 pl-3 py-0 text-right" v-else
                  >Produto</span
                >
              </v-col>
              <v-col cols="4">
                <span
                  class="text-left pr-12 pl-2 py-0 float-right"
                  v-if="
                    valorFrete === retornoValorFreteNull || valorFrete === true
                  "
                  >{{ parseFloat(totalPedidoComFrete).toFixed(2).replace('.', ',') | currency }}</span
                >
                <span class="text-left pr-12 pl-2 py-0 float-right" v-else>{{
                  parseFloat(totalPedidoSemFrete).toFixed(2).replace('.', ',') | currency
                }}</span>
              </v-col>

              <v-col cols="7" class="mt-3">
                <span
                  class="text-left pr-12 pl-2 pb-4 font-weight-black subtitle-1 text-right"
                  >TOTAL</span
                >
              </v-col>
              <v-col cols="4" class="mt-3">
                <span
                  class="text-left pr-12 pl-2 pb-4 font-weight-black subtitle-1 float-right"
                  >{{ parseFloat(totalPedidoComFrete).toFixed(2).replace('.', ',') | currency }}</span
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>

      <vs-button
        style="min-width: 70px;"
        color="warning"
        class="float-right mr-2 mt-8"
        animation-type="scale"
        @click="finalizarPedido()"
      >
        <i class="las la-check" style="font-size: 20px !important"></i>
        <template>Finalizar Pedido</template>
      </vs-button>
    </div>

    <div class="hidden-md-and-up">
      <v-row
        class="white mx-1"
        style="border-bottom: 3px solid var(--vs-cinza) !important;"
        v-if="carrinho.length > 0"
      >
        <v-col cols="12" class="pl-3 pb-0 pt-3">
          <p
            class="text-left font-weight-black title grey--text text--darken-2 mb-0"
          >
            Carrinho
          </p>
        </v-col>

        <v-col cols="6" class="py-0">
          <span class="text-left pr-0 pl-3 py-0">Frete</span>
        </v-col>
        <v-col cols="6" class="py-0">
          <span
            class="text-left pr-3 pl-2 py-0 float-right"
            v-if="valorFrete === retornoValorFreteNull"
            ></span
          >
          <span
            class="text-left pr-3 pl-2 py-0 float-right"
            v-else-if="valorFrete == retornoValorFreteZero"
            >FRETE GRÁTIS</span
          >
          <span
            class="text-left pr-3 pl-2 py-0 float-right"
            v-else-if="valorFrete === true"
          ></span>
          <span class="text-left pr-3 pl-2 py-0 float-right" v-else>{{
            parseFloat(valorFrete).toFixed(2).replace('.', ',') | currency
          }}</span>
        </v-col>
        <v-col cols="6" class="py-0">
          <span
            class="text-left pr-0 pl-3 py-0 text-right"
            v-if="carrinho.length > 1"
            >{{ carrinho.length }} produtos</span
          >
          <span class="text-left pr-0 pl-3 py-0 text-right" v-else
            >Produto</span
          >
        </v-col>
        <v-col cols="6" class="py-0">
          <span
            class="text-left pr-3 pl-2 py-0 float-right"
            v-if="valorFrete === retornoValorFreteNull || valorFrete === true"
            >{{ parseFloat(totalPedidoComFrete).toFixed(2).replace('.', ',') | currency }}</span
          >
          <span class="text-left pr-3 pl-2 py-0 float-right" v-else>{{
            parseFloat(totalPedidoSemFrete).toFixed(2).replace('.', ',') | currency
          }}</span>
        </v-col>

        <v-col cols="6" class="py-0">
          <span
            class="text-left pr-3 pl-2 pb-4 font-weight-black subtitle-1 text-right"
            >TOTAL</span
          >
        </v-col>
        <v-col cols="6" class="py-0">
          <span
            class="text-left pr-3 pl-2 pb-4 font-weight-black subtitle-1 float-right"
            >{{ parseFloat(totalPedidoComFrete).toFixed(2).replace('.', ',') | currency }}</span
          >
        </v-col>
      </v-row>

      <div v-if="carrinho.length > 0">
        <v-card
          v-for="(c, i) in carrinho"
          :key="i"
          style="border-radius: 4px !important;"
          class="mt-4"
        >
          <v-row no-gutters>
            <v-col cols="2" class="pa-0 d-flex align-center justify-center">
            </v-col>

            <v-col cols="10" class="pa-0">
              <div class="text-left subtitle-1 font-weight-bold pl-4 pr-2 pt-5">
                {{ c.anuncio.fitStrCoditefabricante }} -
                {{ c.anuncio.fitStrNme }}
              </div>
              <div class="d-flex">
                <v-row no-gutters>
                  <v-col cols="4" class="d-flex">
                    <span class="text-left body-2 font-weight-bold pl-4 pt-5"
                      >Qtd.</span
                    >
                    <span>
                      <v-text-field
                        min="1"
                        max="100"
                        v-model="c.carIntQtd"
                        @input="alterarQuantidade(c)"
                        type="number"
                        required
                        style="width:50px;"
                        id="numeroCentralizado"
                        class="pt-1 mt-0 ml-2"
                      ></v-text-field>
                    </span>
                  </v-col>
                  <v-col cols="8" class="d-flex align-center justify-end">
                    <div class="float-right algin-end">
                      <span class="text-left body-1 font-weight-bold pl-4">
                        {{
                          parseFloat((c.anuncio.ancFltPrecoVendaDesconto * c.carIntQtd)).toFixed(2).replace('.', ',')
                            | currency
                        }}
                      </span>
                      <v-btn
                        text
                        @click="removerCompra(i)"
                        class="pa-0 mr-4"
                        style="min-width: 32px;"
                      >
                        <v-icon
                          small
                          dark
                          color="var(--vs-vermelho)"
                          class="algin-end pa-0"
                          >delete</v-icon
                        >
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </div>

      <v-card class="mt-4 mb-12" style="border-radius: 4px !important;">
        <v-row no-gutters>
          <v-col cols="12" class="pl-12 pr-12">
            <OpcaoEntega class="mt-4" />

            <CalcFrete v-if="tipoEntrega === 'FRT'" />

            <vs-button
              style="min-width: 70px"
              color="warning"
              class="float-right mr-2 mb-8"
              animation-type="scale"
              @click="finalizarPedido()"
              v-if="carrinho.length > 0"
            >
              <i class="las la-check" style="font-size: 20px !important"></i>
              <template>Finalizar Pedido</template>
            </vs-button>
          </v-col>
        </v-row>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CalcFrete from "@/components/CalcularFrete.vue";
import OpcaoEntega from "../components/OpcaoEntrega";

export default {
  components: {
    CalcFrete,
    OpcaoEntega,
  },
  data() {
    return {
      retornoValorFreteNull:
        "Não há uma tabela de valores de frete para sua região! Favor entrar em contato com a concessionária via chat.",
      retornoValorFreteZero: 0.0,
    };
  },
  methods: {
    alterarQuantidade(c) {
      this.$store.dispatch("pedido/alterarCarrinho", c);
      this.$store.dispatch("pedido/totalPedidoSemFrete");
      this.$store.dispatch("pedido/totalPedidoComFrete");
    },
    removerCompra(idx) {
      this.$store.dispatch("pedido/removerCarrinho", idx);
    },
    finalizarPedido() {
      if (this.user) {
        this.$store.dispatch("pedido/carregarQtdParcelas", {
          empIntCod: this.$route.params.id,
          totalPedido: this.totalPedidoComFrete,
        });
        this.$router.push({ name: "finalizarpedido" });
      } else {
        this.$router.push({ name: "login" });
      }
    },
  },
  mounted() {
    if(this.valorFrete < 0 || this.valorFrete === undefined) {
      this.$store.commit("pedido/setValorFrete", true)
    }
  },
  computed: {
    ...mapGetters({
      carrinho: "pedido/carrinho",
      pedido: "pedido/pedido",
      tipoEntrega: "pedido/tipoEntrega",
      valorFrete: "pedido/valorFrete",
      totalPedidoComFrete: "pedido/totalPedidoComFrete",
      totalPedidoSemFrete: "pedido/totalPedidoSemFrete",
      user: "cliente/user",
      orcamento: "cliente/orcamento",
    }),
  },
};
</script>

<style>
.theme--light.v-data-table tfoot tr:last-child th {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}
tbody:before,
tbody:after {
  content: "-";
  display: block;
  line-height: 1em;
  color: transparent;
}

#numeroCentralizado {
  text-align: center !important;
}

.height-30px {
  height: 30px !important;
}

.carrinho-table {
  max-height: 55vh;
  overflow-y: auto;
}

@media (max-width: 1366px) {
  .carrinho-table {
    max-height: 45vh;
  }
}

@media (max-width: 1024px) {
  .carrinho-table {
    max-height: 40vh;
  }
}

@media (min-width: 1920px) {
  .carrinho-table {
    max-height: 55vh;
  }
}
</style>
